// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2Po8c","title":"Info_title__2e8Mx","links":"Info_links__1E_00","link":"Info_link__3Xve8","logo":"Info_logo__buP_o"};